import { useApiQuery } from 'theSource/utils';
import { useConfigurationQuery } from 'theSource/queries';
import { UnumApplicationResponseDto } from '.';

export interface UnumApplicationQueryProps {
  orgBenefitId: number;
  enrollmentContext: string;
  enabled?: boolean;
}

export const useUnumApplicationQuery = ({
  orgBenefitId,
  enrollmentContext,
  enabled = true,
}: UnumApplicationQueryProps) => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  const {
    data: unumApplicationData,
    isLoading: isLoadingUnumApplication,
    isFetching: isFetchingUnumApplication,
  } = useApiQuery<UnumApplicationResponseDto>({
    queryKey: `unum-application-${String(orgBenefitId)}`,
    config: {
      baseURL: `${apiHost}/v2/self_service`,
    },
    endpoint: `/plugins/unum/application/${orgBenefitId}`,
    params: {
      enroll_type: enrollmentContext,
    },
    enabled: enabled,
  });

  return {
    unumApplicationData,
    isLoadingUnumApplication,
    isFetchingUnumApplication,
  };
};
